export default __webpack_public_path__ + "static/media/nftSystemMb.4a58b47e.png";